import React from 'react'
import { StyledToggleSwitchContainer } from './styles';
import { Check } from '../icons/Check';

interface ToggleSwitchProps {
  onClick: (e) => void;
  checked?: boolean;
}

export const ToggleSwitch = ({checked, onClick}: ToggleSwitchProps) => {
  const onHandleChange = () => {
    onClick(!checked);
  };

  return (
    <StyledToggleSwitchContainer
      className="switch"
      onClick={onHandleChange}
      isChecked={checked}
    >
      <input type="checkbox" checked={checked} />
      <span className={`slider ${checked ? 'active' : 'disabled'}`}>
        <Check iconSize={18} color={'#fff'} />
      </span>
    </StyledToggleSwitchContainer>
  )
}
